import {
  Button,
  Dialog,
  DialogContent,
  CardHeader,
  CardContent,
  CardActions,
  Grid,
  Typography,
  Icon,
} from "../../../../../components";

const ErrosEmitirDialog = ({ open, setOpen, errosEmitir }) => {
  return (
    <Dialog disableEscapeKeyDown maxWidth="md" fullWidth open={open}>
      <form>
        <DialogContent>
          <CardHeader
            title="Erros NFSe"
            action={
              <>
                <Icon>
                  <i
                    className="ph-fill ph-circle"
                    style={{
                      color: "#EA9D2B",
                    }}
                  ></i>
                </Icon>
              </>
            }
          />
          <CardContent>
            <Grid container className="mt-3">
              <Typography>{`${errosEmitir?.code}: ${errosEmitir?.description}`}</Typography>
            </Grid>
          </CardContent>
          <CardActions className="d-flex justify-content-end">
            <Button
              variant="contained"
              color="padrao"
              onClick={() => {
                setOpen(false);
              }}
            >
              Fechar
              <i
                className="ph-fill ph-x-circle"
                style={{ fontSize: 22, marginLeft: 10 }}
              ></i>
            </Button>
          </CardActions>
        </DialogContent>
      </form>
    </Dialog>
  );
};

export default ErrosEmitirDialog;
